import { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import { useSelector } from "react-redux";
import { getAuthState } from "../redux/slices/authSlice";

interface JwtPayload {
  userId: string | null;
  clientId: string | null;
  exp?: number | null;
}

export function isValidToken(token: string): boolean {
  const decodedToken: JwtPayload = jwtDecode(token);
  const currentTime = Date.now() / 1000;
  return (decodedToken.exp && decodedToken.exp > currentTime) || false;
}

// Custom hook for obtaining the token
export function useToken(): string | null {
  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    const tokenKey = `${process.env.REACT_APP_JWT_TOKEN_KEY}`;
    const token = tokenKey ? localStorage.getItem(tokenKey) : null;

    setToken(token);
  }, []);

  return token;
}

// Custom hook for obtaining the userId and clientId
export function useProfile(): JwtPayload {
  const { clientId, userId } = useSelector(getAuthState);

  return { clientId, userId };
}
